import {initYouTubeVideo} from './youtube';
import {FIGURE_CLASS} from './constants';
import {initCdsvideo} from './initCdsvideo';

const initCds2Video = () => {
	document.querySelectorAll( 'section.cds2-video' ).forEach( ( component ) => {
		const figure = component.querySelector( 'figure' );

		if ( !figure )
		{
			return;
		}
		
		const youtubeVideoContainer = figure.querySelector( 'span.youtube-video-wrapper' );
		
		if ( youtubeVideoContainer )
		{
			const youtubeVideoId = youtubeVideoContainer.getAttribute( 'data-youtube-video-id' );
			
			if ( !youtubeVideoId )
			{
				return;
			}
			const youtubeStartTime = youtubeVideoContainer.getAttribute( 'data-start' );

			if ( youtubeStartTime )
			{
				initYouTubeVideo( figure, youtubeVideoContainer, youtubeVideoId, youtubeStartTime );
			}
			else
			{
				initYouTubeVideo( figure, youtubeVideoContainer, youtubeVideoId );
			}
		}

		const cdsvideoContainer = figure.querySelector( 'span.cdsvideo-wrapper' );

		if ( cdsvideoContainer )
		{
			initCdsvideo( figure, cdsvideoContainer );
		}

		const imgCover = figure.querySelector( 'picture > img' );

		if ( imgCover )
		{
			const loadImage = setInterval( () => {
				if ( imgCover.complete && imgCover.naturalWidth > 0 && imgCover.naturalHeight > 0 )
				{
					clearInterval( loadImage );

					figure.classList.add( FIGURE_CLASS.SHOW_COVER );
				}
			}, 10 );
		}

		const videoWrapper = figure.querySelector( 'div.video-wrapper' );
		
		if ( videoWrapper )
		{
			if ( figure.classList.contains( FIGURE_CLASS.YOUTUBE_VIDEO_WITH_VIDEO_COVER ) || figure.classList.contains( FIGURE_CLASS.CDSVIDEO_WITH_VIDEO_COVER ) )
			{
				videoWrapper.querySelectorAll( 'video' ).forEach( ( videoNode ) => {
					const checkVideoReady = setInterval( () => {
						if ( figure.classList.contains( FIGURE_CLASS.SHOW_VIDEO_COVER ) || videoNode.readyState === 4 )
						{
							figure.classList.add( FIGURE_CLASS.SHOW_VIDEO_COVER );
							clearInterval( checkVideoReady );
						}
					}, 10 );
				} );
			}
			else if ( figure.classList.contains( FIGURE_CLASS.PLAIN_VIDEO ) || figure.classList.contains( FIGURE_CLASS.PLAIN_VIDEO_WITH_COVER ) )
			{
				videoWrapper.querySelectorAll( 'video' ).forEach( ( videoNode ) => {
					videoNode.removeAttribute( 'loop' );
					videoNode.removeAttribute( 'autoplay' );
					videoNode.removeAttribute( 'muted' );
					videoNode.pause();
					videoNode.currentTime = 0;

					const checkVideoReady = setInterval( () => {
						if ( figure.classList.contains( FIGURE_CLASS.SHOW_VIDEO_COVER ) || videoNode.readyState === 4 )
						{
							figure.classList.add( FIGURE_CLASS.LOADED );
							figure.classList.remove( FIGURE_CLASS.LOADING );
							figure.classList.remove( FIGURE_CLASS.SHOW_COVER );
							figure.classList.remove( FIGURE_CLASS.SHOW_VIDEO_COVER );

							clearInterval( checkVideoReady );

							const handleInitClick = () => {
								figure.classList.add( FIGURE_CLASS.CLICKED );
				
								if ( videoNode )
								{
									videoNode.setAttribute( 'controls', 'true' );
									const playingHack = setInterval( () => {
										if ( videoNode.played.length === 0 )
										{
											videoNode.play();
										}
										else
										{
											clearInterval( playingHack );
										}
									}, 10 );
									
									videoNode.play();
								}
					
								figure.removeEventListener( 'click', handleInitClick );
							};
					
							figure.addEventListener( 'click', handleInitClick );
						}
					}, 10 );
				} );
			}
		}
	} );
};

export {
	initCds2Video,
};
